// extracted by mini-css-extract-plugin
export default {"form":"styles_form__rln2c","descriptionButtons":"styles_descriptionButtons__VTi1E"};